// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f84a3c32","453":"24289483","455":"979b1337"}[chunkId] + ".chunk.js";
};